module.exports = __webpack_public_path__ + "img/p_map02.c57bc61d.png";